import { FastField } from 'formik';
import { SttInput } from '@stt-componentes/core';
import { MEDICO_EXECUTOR } from '../fieldNames';

const MedicoExecutor = ({ strings }) => {
    
    return (
        <FastField name={MEDICO_EXECUTOR}>
            {({
                field
            }) => (
                <SttInput
                    {...field}
                    label={strings.medicoExecutor}
                />
            )}
        </FastField>
    );
};

export default MedicoExecutor;